import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import connect from 'react-redux/es/connect/connect';
import EventListener from 'react-event-listener';
import { hideCTXMenu } from 'redux/modules/contextMenu';
import Link from 'react-router-dom/Link';
import './context-menu.css';

class ContextMenu extends PureComponent {
    static propTypes = {
        items: PropTypes.array.isRequired,
        visible: PropTypes.bool.isRequired,
        width: PropTypes.number,
        title: PropTypes.string.isRequired,
        parent: PropTypes.object.isRequired,
        dispatch: PropTypes.func.isRequired,
    }

    componentDidMount() {
        if (this.refs.elem && this.props.visible) {
            const dim = this.refs.elem.getBoundingClientRect();

            if (dim.top + dim.height > window.innerHeight) {
                this.refs.elem.style.top = `${(this.props.parent.top - dim.height) + this.container.scrollTop}px`;
            }
        }
    }

    componentWillReceiveProps() {
        if (!this.container) {
            this.container = document.querySelector('#outer-container');
        }
    }

    componentDidUpdate() {
        if (this.refs.elem && this.props.visible) {
            const dim = this.refs.elem.getBoundingClientRect();

            if (dim.top + dim.height > window.innerHeight) {
                this.refs.elem.style.top = `${(this.props.parent.top - dim.height) + this.container.scrollTop}px`;
            }
        }
    }

    renderTitle = () => {
        if (this.props.title && this.props.title.length) {
            return (
                <h5>{this.props.title}</h5>
            );
        }
    }

    renderItems = () => {
        let itemsList = [];

        this.props.items.forEach((item, indx) => {
            if (item.type === 'ext-link') {
                itemsList.push(
                    <a href={item.url}
                        target={item.target || '_blank'}
                        className={`context-menu__item ${item.className}`}
                        key={`ctx_${indx}`}>
                        {item.text}
                    </a>
                );
            }
            else if (item.type === 'action') {
                itemsList.push(
                    <a href='#no-action'
                        onClick={(e) => {
                            e.preventDefault();
                            this.props.dispatch(hideCTXMenu());
                            item.actionFn(e);
                        }}
                        className={`context-menu__item ${item.className}`}
                        key={`ctx_${indx}`}>
                        {item.text}
                    </a>
                );
            }
            else if (item.type === 'component') {
                itemsList.push(
                    <div key={`ctx_${indx}`}>
                        {item.data}
                    </div>
                );
            }
            else if (item.route) {
                itemsList.push(
                    <Link
                        to={item.route}
                        className={`context-menu__item ${item.className}`}
                        key={`ctx_${indx}`}>
                        {item.text}
                    </Link>
                );
            }
        });

        return itemsList;
    }

    closeContextMenu = (e) => {
        if (!e.target.closest('.context-menu')) {
            this.props.dispatch(hideCTXMenu());
        }
    }

    getMenuPosition = () => {
        if (!this.props.visible) {
            return {
                opacity: '0',
                left: '-9999px'
            };
        }
        else if (this.container) {
            let scrollTop = this.container.scrollTop;
            let parent = this.props.parent;
            let width = this.props.width;
            let top = parent.top + parent.height + scrollTop;
            let left = parent.left - ((width || 150) - parent.width);

            left = left > parent.left ? parent.left : left;
            left = (left + (width || 150) >= window.innerWidth) ? window.innerWidth - (width || 150) : left;
            left = left <= 15 ? 15 : left;

            return {
                top,
                left,
                width: width || 150,
                maxWidth: width || 150,
                opacity: '1',
            };
        }
    }

    render() {
        return (
            <div>
                <div ref='elem' className='context-menu' style={this.getMenuPosition()}>
                    {this.renderTitle()}
                    {this.renderItems()}
                </div>
                { this.props.visible ? <EventListener target='document' onClick={this.closeContextMenu} /> : null}
            </div>
        );
    }
}


function mapStateToProps({ CTXMenu }) {
    return {
        items: CTXMenu.items,
        title: CTXMenu.title,
        visible: CTXMenu.showCTX,
        parent: CTXMenu.parent,
        width: CTXMenu.width,
    };
}

export default connect(
    mapStateToProps
)(ContextMenu);



// WEBPACK FOOTER //
// ./src/components/ContextMenu/ContextMenu.js